import DataQuery, { SortOrder } from '../../../../common/scripts/Toolkit/Helper/DataQuery';
import DataType from '../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import LobbyJackpotModel from '../../../../tableEngine/Script/Game/Data/Model/LobbyJackpotModel';
import Lobby from '../../../System/Lobby';
import { LobbyPathName } from '../Config/LobbyPathConfig';

export default class CustomLobbyJackpotModel extends LobbyJackpotModel {
    protected _jackpotRecordQuery: DataQuery<DataType.Jackpot.WinRecordData> = null;

    constructor() {
        super();
        this._jackpotRecordQuery = new DataQuery<DataType.Jackpot.WinRecordData>({
            query: async (page, pageSize) => {
                const response: DataType.Jackpot.RecordResponseData = await Lobby.connection.send(LobbyPathName.JackpotRecord, {
                    Page: page,
                    PageSize: pageSize,
                });
                return response.Data;
            },
            getDataIndex: (data) => data.ID,
            isSameData: (data1, data2) => data1.TransactionID === data2.TransactionID && data1.TriggerTxID === data2.TriggerTxID,
            sortOrder: SortOrder.Descending,
            chunkSize: DataQuery.DEFAULT_CHUNK_SIZE,
        });
    }

    public init() {
        Lobby.connection.on(LobbyPathName.Login, this.onLoginDataReceived, this);
        Lobby.connection.on(LobbyPathName.JackpotStatus, this.onJackpotStatusReceived, this);
    }

    public getWinRecords(): Readonly<DataType.Jackpot.WinRecordData[]> {
        // HACK
        // if (TableGame.user.isTrial && !this._winRecords.length) {
        //     return [...dummyJackpotRecords, ...dummyJackpotRecords, ...dummyJackpotRecords];
        // }
        return this._jackpotRecordQuery.dataList;
    }

    public async syncLatestWinRecords(): Promise<void> {
        if (!this.isJackpotApplied) {
            return;
        }
        await this._jackpotRecordQuery.checkSyncState();
    }

    public async requestNewJackpotWinRecord() {
        await this._jackpotRecordQuery.requestForNewData();
    }

    public requestJackpotStatus(): Promise<void> {
        if (!this.isJackpotApplied) {
            return Promise.resolve();
        }
        return Lobby.connection.send(LobbyPathName.JackpotStatus);
    }

    protected onLoginDataReceived(): void {
        this._applyJackpot = true;
    }

    protected onJackpotStatusReceived(data: DataType.Jackpot.StatusResponseData) {
        if (!data || !this._applyJackpot) {
            return;
        }
        this.handleJackpotStatus(data);
    }

    protected handleJackpotStatus(data: DataType.Jackpot.StatusResponseData) {
        if (!data?.Jackpots) {
            return;
        }
        const jackpotPoolType = Lobby.hall.currentHallID.toString();
        data.Jackpots.forEach((jackpotData) => {
            if (!this.poolMap[jackpotPoolType]) {
                this.poolMap[jackpotPoolType] = {};
            }
            this.poolMap[jackpotPoolType][jackpotData.Level] = jackpotData;
        });

        this.emit(CustomLobbyJackpotModel.EVENT_TYPE.JACKPOT_STATUS_UPDATED);
    }

    protected handleWinRecord(data: DataType.Jackpot.WinRecordData[]): void {
        if (!data?.length) {
            return;
        }
        this.emit(CustomLobbyJackpotModel.EVENT_TYPE.JACKPOT_WIN_RECEIVED);
    }
}
